import React from "react";
import { Link } from "react-router-dom";
import Layout from "../components/layout";
import Button from "../components/button";
import projects from "../data/projects";
import Deco from "../components/Deco";

export default function WorkPage() {
  return (
    <Layout>
      <div className="deco-wrap">
        <Deco name="three" className="deco-work deco-work--top" />
        <Deco name="six" className="deco-work deco-work--bottom" />
      </div>
      <div className="container py-5">
        <div className="work-header">
          <h1 className="mb-3">Our Work</h1>
          <p className="text-muted mb-4">
            A selection of projects across branding, web, and design. Click any
            project to see a deeper breakdown.
          </p>
          <Button to="/contact" type="cta">
            Start a project
          </Button>
        </div>

        <div className="work-grid">
          {projects.map((project) => (
            <div
              key={project.id}
              className={`work-card-wrap work-card-wrap--${project.outlineStyle || "black"}`}
            >
              <Link
                to={`/work/${project.id}`}
                className="work-card"
                style={{ backgroundImage: `url(${project.heroImage})` }}
              >
                <div className="work-card__overlay" />
                <div className="work-card__content">
                  <div className="work-card__category">{project.category}</div>
                  <div className="work-card__title">{project.title}</div>
                  <div className="work-card__cta">View project</div>
                </div>
              </Link>
            </div>
          ))}
        </div>
      </div>
    </Layout>
  );
}
